import React from 'react';

const AboutChannelComponent = ({description, channelConfig}) => {
    return(
        <div className="channel-description" style={{color: channelConfig?channelConfig.text_color:''}}>
            {description}
        </div>
    )
}

export default AboutChannelComponent;
